// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bej_a bhg_tp","StrollerBoxWidget__imageCounselling":"bej_b bhg_ke"};